import { render, staticRenderFns } from "./createswitch.vue?vue&type=template&id=8655bd2a&"
import script from "./createswitch.vue?vue&type=script&lang=ts&"
export * from "./createswitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createswitch.vue"
export default component.exports